import styled from 'styled-components/macro'

const CustomCheckbox = styled.div`
  position: relative;
  text-align: left;

  label {
    cursor: pointer;
    display: inline;
    line-height: 1.25em;
    vertical-align: top;
    clear: both;
    padding-left: 1px;
    &:not(:empty) {
      padding-left: 0.25em;
    }

    &:before,
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
    }

    &:before {
      // box
      width: 1.25em;
      height: 1.25em;
      background: #fff;
      border: 2px solid #003399;
      border-radius: 3px;
      cursor: pointer;
      transition: background 0.3s;
    }

    &:after {
      // checkmark
    }
  }

  input[type='checkbox'] {
    outline: 0;
    visibility: hidden;
    width: 0.75em;
    margin: 0;
    display: block;
    float: left;
    font-size: inherit;

    &[value='true'] {
      + label:before {
        background: white;
        border: 2px solid #003399;
      }
      + label:after {
        transform: translate(0.25em, 0.33654em) rotate(-45deg);
        width: 0.75em;
        height: 0.375em;

        border: 2px solid #003399;
        border-top-style: none;
        border-right-style: none;
      }
    }
    ${props =>
      props.isChecked
        ? `
      + label:before {
        background: #003399;
        border: none;
      }
      + label:after {
        transform: translate(0.25em, 0.33654em) rotate(-45deg);
        width: 0.75em;
        height: 0.375em;

        border: 0.125em solid #fff;
        border-top-style: none;
        border-right-style: none;
      }
    `
        : ''}
  }
`

export default CustomCheckbox
